module.exports = __webpack_public_path__ + "img/8_827fc395f.png";